<div class="placeholder-container">
  <ng-container *ngFor="let n of rowSequence(rows)">
    <div class="placeholder"></div>
  </ng-container>
</div>
